import { IOption } from '@store/rootResource'

export {
  AnalyticsBreakdownFilter,
  type IAnalyticsBreakdownFilterProps,
} from './AnalyticsBreakdownFilter'

export const DURATION_OPTIONS: IOption[] = [
  { label: '28 Days', value: '28_days' },
  { label: '60 Days', value: '60_days' },
  { label: '90 Days', value: '90_days' },
  { label: 'Lifetime', value: 'lifetime' },
]

export const CONTENT_TYPE_OPTIONS: IOption[] = [
  { label: 'Overall', value: 'overall' },
  { label: 'Video on Demand', value: 'vod' },
  { label: 'Shorts', value: 'shorts' },
]

export const SOURCE_OPTIONS: IOption[] = [
  { label: 'Organic', value: 'organic' },
  { label: 'Paid', value: 'paid' },
  { label: 'Total', value: 'total' },
]

export const defaultDurationOption = DURATION_OPTIONS[0]
export const defaultContentTypeOption = CONTENT_TYPE_OPTIONS[0]
export const defaultSourceOption = SOURCE_OPTIONS[2]
